<template>
  <div>
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showotpsnack" color="#00a972" right :timeout="5000">
      One-time PIN send Successfully
      <v-btn text @click="showotpsnack = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-layout wrap pt-10 justify-center>
      <v-flex xs2 md2 pl-5>
        <v-img @click="pageBack" src="../../assets/icons/back.png" height="50px" width="50px">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-flex>
      <v-flex xs12 md8 text-center align-self-end>
        <span
          style="font-size:20px;font-weight:500;"
        >One-time PIN send to {{countryCode}} {{phoneNo}}</span>
      </v-flex>
      <v-flex xs12 md2></v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 md12 text-center>
        <span style="font-size:16px;font-weight:400;color:#a9a9a9">{{mailId}}</span>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center pt-12>
      <v-flex xs12 md12 text-center>
        <span style="font-size:14px;font-weight:300;color:#a9a9a9;">Enter One-time PIN</span>
      </v-flex>
    </v-layout>
    <v-layout justify-center pt-3>
      <v-flex xs12 md3 text-center pl-4>
        <vie-otp-input
          inputClasses="otp-input"
          :numInputs="5"
          separator
          :shouldAutoFocus="true"
          @on-complete="validateOTP"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12 md3 pl-6>
        <span
          v-if="!otpexpired"
          style="font-size:14px;font-weight:300;color:#a9a9a9;"
        >Your one-time PIN will expire in {{ timeLeft }}</span>
        <span v-else style="font-size:14px;font-weight:300;color:red;">Your one-time PIN has expired</span>
      </v-flex>
    </v-layout>
    <v-layout v-if="showotpbtn" wrap justify-center>
      <v-flex xs12 md3 pl-6>
        <span
          @click="resendOTP"
          onmouseover="this.style.cursor='pointer'"
          style="font-size:12px;font-weight:500;color:#a9a9a9;"
        >Resend Code</span>
      </v-flex>
    </v-layout>
    <v-layout justify-center pt-12 pl-5>
      <v-flex v-if="OTPVerified" xs12 md2 align="center">
        <v-img src="../../assets/icons/verification.png" aspect-ratio="1" contain height="50px">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-flex>
    </v-layout>
    <v-layout justify-center pt-3>
      <v-flex v-if="OTPVerified" xs12 md12 text-center>
        <span style="font-size:16px;font-weight:400;color:#26af82;">OTP Verification Successful</span>
      </v-flex>
    </v-layout>
    <v-layout justify-center pt-3>
      <v-flex xs12 md12 text-center>
        <span style="font-size:16px;font-weight:400;color:red;">{{msg}}</span>
      </v-flex>
    </v-layout>
    <v-layout pt-5 wrap justify-center pb-12>
      <v-flex xs12 md12 text-center>
        <br />
        <v-btn
          width="220"
          class="text-capitalize"
          :ripple="false"
          color="#26af82"
          dark
          small
          @click="submit"
        >Submit</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

import VieOtpInput from "@bachdgvn/vue-otp-input";
export default {
  components: {
    VieOtpInput
  },
  props: ["signupData"],
  data() {
    return {
      OTP: null,
      // OTP: "qscef",
      OTPVerified: false,
      appLoading: false,

      countryCode: null,
      phoneNo: null,
      mailId: null,
      authcode: null,
      userId: null,
      msg: null,
      showotpbtn: false,
      timeLeft: "00:00",
      intervalTimer: null,
      showotpsnack: false,
      otpexpired: false,
      ServerError: false
    };
  },
  beforeMount() {
    this.setTime(420);
  },
  mounted() {
    this.appLoading = true;
    this.countryCode = this.signupData.countryCode;
    this.phoneNo = this.signupData.phoneNo;
    this.mailId = this.signupData.mailId;
    this.authcode = this.signupData.authcode;
    this.userId = this.signupData.userId;
    this.appLoading = false;
  },
  methods: {
    pageBack() {
      this.$emit("stepper", {
        winStep: 0,
        authcode: this.authcode,
        userId: this.userId,
        userName: this.signupData.userName,
        countryCode: this.signupData.countryCode,
        phoneNo: this.signupData.phoneNo,
        mailId: this.signupData.mailId,
        password: this.signupData.password,
        confPassword: this.signupData.confPassword,
        inptDisable: true,
        otpexpired: false
      });
    },
    validateOTP(value) {
      this.OTP = value;
      this.submit();
    },
    resendOTP() {
      var data = {};
      data["id"] = localStorage.getItem("userId");
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/sendotp",
        params: {
          id: this.userId
        }
      })
        .then(response => {
          this.setTime(420);
          if (response.data.status) {
            this.msg = response.data.msg;
            this.msg = null;
            this.showotpbtn = false;
            this.showotpsnack = true;
            this.appLoading = false;
            this.otpexpired = false;
          } else {
            this.msg = response.data.msg;
            this.appLoading = false;
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    submit() {
      this.appLoading = true;
      var verdata = {};
      verdata["authcode"] = this.OTP;
      verdata["id"] = this.userId;

      axios({
        method: "POST",
        url: "/user/verifyphone",
        data: verdata
      })
        .then(response => {
          this.msg = response.data.msg;
          if (response.data.status) {
            this.OTPVerified = true;
            // setTimeout(() => {
            this.$emit("stepper", { winStep: 2, mailId: this.mailId });
            // }, 3000);
            this.appLoading = false;
          } else {
            this.appLoading = false;
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    setTime(seconds) {
      clearInterval(this.intervalTimer);
      this.timer(seconds);
    },
    timer(seconds) {
      const now = Date.now();
      const end = now + seconds * 1000;
      this.displayTimeLeft(seconds);
      this.countdown(end);
    },
    countdown(end) {
      this.intervalTimer = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000);
        if (secondsLeft == 350) this.showotpbtn = true;
        if (secondsLeft == 0) this.otpexpired = true;

        if (secondsLeft < 0) {
          clearInterval(this.intervalTimer);
          return;
        }
        this.displayTimeLeft(secondsLeft);
      }, 1000);
    },
    displayTimeLeft(secondsLeft) {
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;
      var seconds1 = seconds;
      if (seconds < 10) seconds1 = "0" + seconds;
      this.timeLeft = "0" + minutes + " : " + seconds1;
    }
  }
};
</script>
<style>
.error {
  border: 1px solid red !important;
}
</style>